import { useTranslation } from "react-i18next";
import { ShareSearchButton } from "./ShareSearchButton";
import { SortToggle, type SortOption } from "./SortToggle";
import { cn } from "@/lib/utils";

interface ResultsHeaderProps {
  tripCount: number;
  tripType: "one-way" | "round-trip";
  currentSort: SortOption;
  onSortChange: (sort: SortOption) => void;
  className?: string;
}

export function ResultsHeader({
  tripCount,
  tripType,
  currentSort,
  onSortChange,
  className,
}: ResultsHeaderProps) {
  const { t } = useTranslation();

  const tripTypeLabel =
    tripType === "round-trip"
      ? t("results.roundTrip")
      : t("results.oneWay");

  return (
    <div
      className={cn(
        "flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 pb-3 border-b hairline-strong",
        className,
      )}
    >
      <div className="flex flex-wrap items-center gap-x-4 gap-y-2">
        <div className="flex items-center gap-2 text-eyebrow uppercase tabular">
          <span className="h-2 w-2 bg-brand" aria-hidden="true" />
          <span className="text-ink">
            {t("trips.tripFound", { count: tripCount })}
          </span>
          <span className="h-1 w-1 bg-ink-subtle" aria-hidden="true" />
          <span className="text-ink-muted">{tripTypeLabel}</span>
        </div>
        <ShareSearchButton />
      </div>

      <SortToggle currentSort={currentSort} onSortChange={onSortChange} />
    </div>
  );
}
